import {getTestProps} from '@benchling/js-test-utils';
import {css} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import Tooltip from 'ui-library/floating-ui/Tooltip';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

import {styles} from './ProcessTaskSchemaEditorStyles';

interface ProcessTaskSchemaEditorSectionProps {
  sectionTitle: string;
  sectionNumber: number;
  children?: React.ReactNode;
  isLastSection?: boolean;
  actionButton?: {
    onClick: () => void;
    tooltipTitle: string;
    icon: BenchlingIconName;
  };
  shouldHideSectionHeader: boolean;
  noSectionSpacing?: boolean;
}

const SectionNumber = ({sectionNumber}: {sectionNumber: number}): JSX.Element => (
  <div className={css(styles.schemaEditorSectionNumber)}>{sectionNumber}</div>
);

export default function ProcessTaskSchemaEditorSection(
  props: ProcessTaskSchemaEditorSectionProps
): JSX.Element {
  return (
    <div
      className={css(styles.schemaEditorSection)}
      {...getTestProps({
        component: 'ProcessTaskSchemaEditorSection',
        element: 'root',
        key: `${props.sectionNumber}`,
      })}
    >
      {!props.shouldHideSectionHeader && (
        <div className={css(styles.schemaEditorSectionHeader)}>
          <SectionNumber sectionNumber={props.sectionNumber} />
          <div
            className="legacy-font-proxima-14"
            {...getTestProps({
              component: 'ProcessTaskSchemaEditorSection',
              element: 'title',
              key: `${props.sectionNumber}`,
            })}
          >
            {props.sectionTitle}
          </div>
          {props.actionButton && (
            <Tooltip text={props.actionButton.tooltipTitle}>
              <button
                type="button"
                aria-label={props.actionButton.tooltipTitle}
                className={classNames(
                  css(styles.schemaEditorSectionActionButton),
                  'faded u-small-padding-left u-small-padding-right pull-right'
                )}
                onClick={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  props.actionButton?.onClick();
                }}
              >
                <BenchlingIcon icon={props.actionButton.icon} />
              </button>
            </Tooltip>
          )}
        </div>
      )}
      <div
        className={css(
          !props.noSectionSpacing && styles.schemaEditorSectionChildrenSpacing,
          !props.isLastSection && !props.shouldHideSectionHeader && styles.schemaEditorSectionChildrenBorder
        )}
      >
        {props.children}
      </div>
    </div>
  );
}
